import { Clickable, Icon, Layout, Text, TextButton } from 'ds';
import { selectServicesPaymentMethod } from 'store/Tenancy/selectors';
import { useAppSelector } from 'store/hooks';

import { ReactComponent as StripeBank } from 'ds/StripeBank.svg';

interface PaymentMethodCardProps {
  onClick: () => void;
  onUpdate: () => void;
}
const PaymentMethodCard = ({ onClick, onUpdate }: PaymentMethodCardProps) => {
  const servicesPaymentMethod = useAppSelector(selectServicesPaymentMethod);

  if (!servicesPaymentMethod) {
    return (
      <Clickable onClick={onClick} fullWidth>
        <Layout
          paddingY={12}
          paddingLeft={12}
          paddingRight={24}
          height={64}
          borderRadius={8}
          justify="space-between"
          align="center"
          borderWidth={1}
        >
          <Layout direction="row" gap={12} align="center">
            <StripeBank />
            <Text size="body-md" semibold>
              Add payment method
            </Text>
          </Layout>
          <Icon name="plus" color="purple-gradient" size="xl" />
        </Layout>
      </Clickable>
    );
  }
  return (
    <Layout
      direction="row"
      paddingY={12}
      paddingX={16}
      borderRadius={8}
      borderColor="gray-50"
      borderWidth={1}
      justify="space-between"
      align="center"
    >
      <Layout direction="row" gap={12} align="center">
        <StripeBank />
        <Layout direction="column">
          <Text size="body-sm" semibold>
            {servicesPaymentMethod.card?.brand
              ? servicesPaymentMethod.card.brand.charAt(0).toUpperCase() + servicesPaymentMethod.card.brand.slice(1)
              : servicesPaymentMethod.us_bank_account?.bank_name}
          </Text>
          <Text size="body-xs" color="gray-400">
            {servicesPaymentMethod.us_bank_account
              ? `•••• ${servicesPaymentMethod.us_bank_account?.last4}`
              : `ending in ${servicesPaymentMethod.card?.last4} (exp ${servicesPaymentMethod.card?.exp_month}/${servicesPaymentMethod.card?.exp_year})`}
          </Text>
        </Layout>
      </Layout>
      <TextButton text="Update" color="blue-500" textSize="body-sm" semibold={false} onClick={onUpdate} />
    </Layout>
  );
};

export default PaymentMethodCard;
